import { request, unwrap } from '../client';
import type {
  ApiResponse,
  BrandDto,
  CreateBrandRequest,
  UpdateBrandRequest,
} from '../types';

const BASE = '/api/saas-admin/brands';

export const brandsApi = {
  async list(productId?: number): Promise<BrandDto[]> {
    const query = productId !== undefined ? { productId } : undefined;
    const res = await request<ApiResponse<BrandDto[]>>(
      'GET',
      BASE,
      query ? { query } : {},
    );
    return unwrap(res);
  },

  async get(id: number): Promise<BrandDto> {
    const res = await request<ApiResponse<BrandDto>>('GET', `${BASE}/${id}`);
    return unwrap(res);
  },

  async create(req: CreateBrandRequest): Promise<BrandDto> {
    const res = await request<ApiResponse<BrandDto>>('POST', BASE, { json: req });
    return unwrap(res);
  },

  async update(id: number, req: UpdateBrandRequest): Promise<BrandDto> {
    const res = await request<ApiResponse<BrandDto>>('PUT', `${BASE}/${id}`, { json: req });
    return unwrap(res);
  },

  async delete(id: number): Promise<void> {
    await request<void>('DELETE', `${BASE}/${id}`);
  },

  async uploadHeroImage(brandId: number, file: File): Promise<BrandDto> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await request<ApiResponse<BrandDto>>('POST', `${BASE}/${brandId}/hero-image`, {
      formData,
    });
    return unwrap(res);
  },

  async uploadLogoImage(brandId: number, file: File): Promise<BrandDto> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await request<ApiResponse<BrandDto>>('POST', `${BASE}/${brandId}/logo-image`, {
      formData,
    });
    return unwrap(res);
  },

  async uploadFaviconImage(brandId: number, file: File): Promise<BrandDto> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await request<ApiResponse<BrandDto>>('POST', `${BASE}/${brandId}/favicon-image`, {
      formData,
    });
    return unwrap(res);
  },
};
